import { useEffect, useRef } from 'react';

export const GraphComments = ({ identifier, title, accentColor = '#E91E8C' }) => {
  const containerRef = useRef(null);
  const scriptLoaded = useRef(false);

  useEffect(() => {
    // Prevent double initialization
    if (scriptLoaded.current) return;
    
    // Clean any existing graphcomment content
    const existingContainer = document.getElementById('graphcomment');
    if (existingContainer) {
      existingContainer.innerHTML = '';
    }

    // GraphComment configuration
    window.__semio__params = {
      graphcommentId: 'vetealaversh',
      behaviour: {
        uid: identifier || window.location.pathname,
      },
    };

    // Callback function that GraphComment calls when script loads
    window.__semio__onload = function() {
      if (typeof window.__semio__gc_graphlogin === 'function') {
        window.__semio__gc_graphlogin(window.__semio__params);
      }
    };

    // Check if script already exists
    const existingScript = document.querySelector('script[src*="gc_graphlogin"]');
    if (existingScript) {
      // Script already loaded, just call the init function
      if (typeof window.__semio__gc_graphlogin === 'function') {
        window.__semio__gc_graphlogin(window.__semio__params);
      }
      scriptLoaded.current = true;
      return;
    }

    // Load the script
    const gc = document.createElement('script');
    gc.type = 'text/javascript';
    gc.async = true;
    gc.defer = true;
    gc.src = 'https://integration.graphcomment.com/gc_graphlogin.js?' + Date.now();
    gc.onload = window.__semio__onload;
    
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(gc);
    scriptLoaded.current = true;

  }, [identifier]);

  // Dynamic styles based on accent color
  const customStyles = `
    #graphcomment {
      --gc-accent: ${accentColor};
    }
    
    /* Main container */
    #graphcomment,
    #graphcomment * {
      font-family: inherit !important;
    }
    
    /* Background and text colors */
    #graphcomment .gc-container,
    #graphcomment .gc-comments-list,
    #graphcomment .gc-comment,
    #graphcomment .gc-form-container {
      background-color: transparent !important;
      color: #fff !important;
    }
    
    /* Comment text */
    #graphcomment .gc-comment-content,
    #graphcomment .gc-comment-text,
    #graphcomment p,
    #graphcomment span {
      color: #e5e5e5 !important;
    }
    
    /* Author names */
    #graphcomment .gc-author-name,
    #graphcomment .gc-comment-author {
      color: ${accentColor} !important;
      font-weight: bold !important;
    }
    
    /* Buttons */
    #graphcomment .gc-btn,
    #graphcomment button {
      background-color: ${accentColor} !important;
      border-color: ${accentColor} !important;
      color: #000 !important;
      font-weight: bold !important;
    }
    
    #graphcomment .gc-btn:hover,
    #graphcomment button:hover {
      opacity: 0.85 !important;
    }
    
    /* Links */
    #graphcomment a {
      color: ${accentColor} !important;
    }
    
    /* Input fields */
    #graphcomment input,
    #graphcomment textarea,
    #graphcomment .gc-textarea,
    #graphcomment .gc-form-comment {
      background-color: #1a1a1a !important;
      border: 2px solid #333 !important;
      color: #fff !important;
    }
    
    #graphcomment input:focus,
    #graphcomment textarea:focus,
    #graphcomment .gc-textarea:focus {
      border-color: ${accentColor} !important;
      outline: none !important;
    }
    
    #graphcomment input::placeholder,
    #graphcomment textarea::placeholder {
      color: #666 !important;
    }
    
    /* Toolbar */
    #graphcomment .gc-toolbar,
    #graphcomment .gc-editor-toolbar {
      background-color: #1a1a1a !important;
      border-color: #333 !important;
    }
    
    #graphcomment .gc-toolbar button,
    #graphcomment .gc-toolbar svg {
      color: #888 !important;
      fill: #888 !important;
    }
    
    #graphcomment .gc-toolbar button:hover,
    #graphcomment .gc-toolbar button:hover svg {
      color: ${accentColor} !important;
      fill: ${accentColor} !important;
    }
    
    /* "Sin comentarios" and other notices */
    #graphcomment .gc-no-comments,
    #graphcomment .gc-empty {
      color: #888 !important;
    }
    
    /* Powered by */
    #graphcomment .gc-powered-by,
    #graphcomment [class*="powered"] {
      opacity: 0.5 !important;
    }
    
    /* Comment count header */
    #graphcomment .gc-header,
    #graphcomment .gc-comments-header {
      color: #fff !important;
      border-bottom-color: #333 !important;
    }
    
    /* Reply buttons and actions */
    #graphcomment .gc-reply-btn,
    #graphcomment .gc-action {
      color: #888 !important;
    }
    
    #graphcomment .gc-reply-btn:hover,
    #graphcomment .gc-action:hover {
      color: ${accentColor} !important;
    }
    
    /* Timestamp */
    #graphcomment .gc-timestamp,
    #graphcomment .gc-date {
      color: #666 !important;
    }
    
    /* Avatar placeholder */
    #graphcomment .gc-avatar {
      border: 2px solid #333 !important;
    }
    
    /* Separator lines */
    #graphcomment hr,
    #graphcomment .gc-separator {
      border-color: #333 !important;
    }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div 
        id="graphcomment"
        ref={containerRef}
        style={{ minHeight: '150px' }}
      />
    </>
  );
};
